import React, { useState } from 'react';
import { SectionHeading } from '../SectionHeading/SectionHeading';
import { Box } from '../../../../CommonComponents/OPL/Box/Box';
import { ShareModal } from '../../../Output/components/ShareModal/ShareModal';
import { InviteType } from '../../../Output/components/ShareModal/ShareModal.meta';
import { Card } from '../../../../CommonComponents/OPL/Card/Card';
import { Text } from '../../../../CommonComponents/OPL/Text/Text';
import { Button } from '../../../../CommonComponents/OPL/Button/Button';
import EnvelopIcon from '../../img/envelop.svg';

export const ShareSection = () => {
  const [inviteType, setInviteType] = useState<InviteType | null>(null);

  return (
    <>
      <Box as="section">
        <Card
          display="flex"
          flexDirection="column"
          alignItems="center"
          mb="24"
          pt="8"
          px="16"
          pb="32"
        >
          <SectionHeading icon={<EnvelopIcon />} mb="24">
            Invite to Compare
          </SectionHeading>

          <Text textAlign="center" color="neutral.600" fontSize="h6" fontWeight={500} mb="24">
            See how your financial values align with those of a partner, family member, or friend.
          </Text>

          <Button onClick={() => setInviteType(InviteType.Compare)} css="width: 174px">
            Send an Invite
          </Button>
        </Card>

        <Box display="flex" flexDirection="column" alignItems="center" mb="24" px="16">
          <Text textAlign="center" color="neutral.600" fontSize="h6" fontWeight={500} mb="24">
            Know someone who could use some financial help? Invite them to check out BeFi20.
          </Text>

          <Button
            variant="secondary"
            onClick={() => setInviteType(InviteType.Share)}
            mt="auto"
            css="width: 174px"
          >
            Share BeFi20
          </Button>
        </Box>
      </Box>

      {inviteType !== null && (
        <ShareModal inviteType={inviteType} onClose={() => setInviteType(null)} />
      )}
    </>
  );
};
